import { useQuery } from '@apollo/client';
import { cobaltIntelligenceApi, CheckVoSosDataResponse, CheckVoSosDataVariables } from '../api';

export function useCheckVoSosData(voId: string) {
  const { data, loading } = useQuery<CheckVoSosDataResponse, CheckVoSosDataVariables>(
    cobaltIntelligenceApi.checkVoSosData,
    { variables: { input: { voId } } }
  );

  const sosCheckResult = data?.cobaltIntelligence?.result?.entity;
  const hasData = sosCheckResult?.hasData ?? true;
  const missingData = sosCheckResult?.missingData ?? null;

  return { hasData, missingData, isCheckLoading: loading };
}
